// Browserify

require('angular');
require('./src/fixed-table-header');

module.exports = 'fixed.table.header';



/*****************
 ** WEBPACK FOOTER
 ** ./~/angular-fixed-table-header/index.js
 ** module id = 637
 ** module chunks = 1
 **/